import 'css-chunksrc/feature/check/CheckPanelFooter.module.scss';export default {
  "root": "CheckPanelFooter_root",
  "viewModeMain": "CheckPanelFooter_viewModeMain",
  "checkDetails": "CheckPanelFooter_checkDetails",
  "viewModeOverlay": "CheckPanelFooter_viewModeOverlay",
  "overlayContainer": "CheckPanelFooter_overlayContainer",
  "handle": "CheckPanelFooter_handle",
  "total": "CheckPanelFooter_total",
  "actions": "CheckPanelFooter_actions",
  "overlayContent": "CheckPanelFooter_overlayContent",
  "checkDetailsMore": "CheckPanelFooter_checkDetailsMore",
  "checkDetailsMoreGrid": "CheckPanelFooter_checkDetailsMoreGrid",
  "checkDetailsMoreCloseBtn": "CheckPanelFooter_checkDetailsMoreCloseBtn",
  "discountsWrapper": "CheckPanelFooter_discountsWrapper",
  "discountCardContainer": "CheckPanelFooter_discountCardContainer",
  "discount_item": "CheckPanelFooter_discount_item",
  "discount_info_icon": "CheckPanelFooter_discount_info_icon",
  "discount_label": "CheckPanelFooter_discount_label",
  "discount_calculated": "CheckPanelFooter_discount_calculated"
};